import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Pagination,
  Grid,
  IconButton,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Collapse, List, ListItem } from "@material-ui/core";
import { useSelector } from "react-redux";
import { SUPER_ROLE } from "scripts/const";
import ConfirmationAlert from "components/Alert/ConfirmationAlert";

const UpdateCard = (props) => {
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = React.useState(null);
  const currentUser = useSelector((state) => state.login.loginUser.detail);
  const isSuperUser = SUPER_ROLE.includes(currentUser.roleId);

  const hideAlert = () => {
    setAlert(null);
  };

  return (
    <Card sx={{ marginBottom: 2 }}>
      {alert}
      <CardContent>
        <Box sx={{ marginBottom: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" component="div">
              {props.title}
            </Typography>
            {isSuperUser && (
              <IconButton
                aria-label="settings"
                onClick={() => setOpen((prev) => !prev)}
              >
                <MoreVertIcon />
              </IconButton>
            )}
          </Box>
          <Collapse in={open} unmountOnExit>
            <List sx={{ padding: 0 }}>
              <ListItem
                style={{ cursor: "pointer" }}
                onClick={() => {
                  props.setEditAnnouncementModal(true);
                  props.setAnnouncementId(props.id);
                }}
              >
                <Typography>Edit</Typography>
              </ListItem>
              <ListItem
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setAlert(
                    <ConfirmationAlert
                      cancel={hideAlert}
                      submit={() => props.handleDelete({ id: props.id })}
                      message={"You are deleting announcement"}
                      style={{
                        display: "block",
                      }}
                    />
                  );
                }}
                sx={{ paddingLeft: 4 }}
              >
                <Typography>Delete</Typography>
              </ListItem>
            </List>
          </Collapse>
        </Box>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {new Date(props.createdAt).toLocaleDateString()} by{" "}
          {props?.user?.firstName} {props?.user?.lastName}
        </Typography>
        {props?.photoURL?.length > 0 && (
          <div className={"thumbnail"}>
            <img
              style={{ width: "100%" }}
              className="picture-src"
              src={props?.photoURL}
              alt="..."
            />
          </div>
        )}
        <div dangerouslySetInnerHTML={{ __html: props.description }} />
      </CardContent>
    </Card>
  );
};
export default UpdateCard;
